import { formatDate } from "./formatDate.ts";

const date = new Date();

export const MONTHS_PT = [
	"janeiro",
	"fevereiro",
	"março",
	"abril",
	"maio",
	"junho",
	"julho",
	"agosto",
	"setembro",
	"outubro",
	"novembro",
	"dezembro",
];

export const anoDoisMilString = "2000-01-01";

export const primeiroDiaDoMes = new Date(
	date.getFullYear(),
	date.getMonth(),
	1,
).toISOString();

export const ultimoDiaDoMes = new Date(
	date.getFullYear(),
	date.getMonth() + 1,
	0,
).toISOString();

export const primeiroDiaDoMesPassado = new Date(
	date.getFullYear(),
	date.getMonth() - 1,
	1,
).toISOString();

export const ultimoDiaDoMesPassado = new Date(
	date.getFullYear(),
	date.getMonth(),
	0,
).toISOString();

export const hojeFormatado = formatDate(new Date());

export const primeiroDiaDosMesFormatado = formatDate(primeiroDiaDoMes);

export const ultimoDiaDosMesFormatado = formatDate(ultimoDiaDoMes);

export const primeiroDiaDosMesPassadoFormatado = formatDate(
	primeiroDiaDoMesPassado,
);

export const ultimoDiaDosMesPassadoFormatado = formatDate(
	ultimoDiaDoMesPassado,
);

export const dateNow = new Date();
export const mesAtual = (dateNow.getMonth() + 1).toString();
export const anoAtual = dateNow.getFullYear().toString();

export const memoizedMonthsOptions = () => {
	return MONTHS_PT.map((month, index) => ({
		obj: (index + 1).toString(),
		title: month.charAt(0).toUpperCase() + month.slice(1),
	}));
};

export const fix2DecimalString = (value: string): string => {
	if (!value) return "0,00";
	if (!value.includes(",")) {
		return value;
	}

	return value.replace(/^(\d+,\d{0,2}).*$/, "$1");
};

export const isDataDoisMil = (data: string): boolean => {
	if (
		typeof data !== "string" ||
		!/^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2})?)?$/.test(data)
	) {
		return false;
	}

	const date = new Date(data);

	if (Number.isNaN(date.getTime())) {
		return false;
	}

	if (
		data === "2000-01-01T00:00:00" ||
		data === "2000-01-01T00:00" ||
		date.getFullYear() === 2000
	) {
		return true;
	}
	return false;
};

export function removeSeconds(dateTimeStr: string): string {
	if (!dateTimeStr) {
		return dateTimeStr;
	}
	return dateTimeStr.slice(0, 16);
}

export function timeToSeconds(time: string): number {
	let isNegative = false;
	if (time.startsWith("-")) {
		isNegative = true;
		time = time.substring(1);
	}
	const parts = time.split(".");
	let days = 0;
	let [hours, minutes, seconds] = [0, 0, 0];
	if (parts.length === 2) {
		days = Number(parts[0]);
		[hours, minutes, seconds] = parts[1].split(":").map(Number);
	} else {
		[hours, minutes, seconds] = parts[0].split(":").map(Number);
	}
	const totalMinutes = days * 86400 + hours * 3600 + minutes * 60 + seconds;
	return isNegative ? totalMinutes : totalMinutes;
}

export function secondsToTime(seconds: number): string {
	let isNegative = seconds < 0;
	if (isNegative) {
		seconds = Math.abs(seconds);
	}

	const hours = Math.floor(seconds / 3600);
	seconds -= hours * 3600;

	const minutes = Math.floor(seconds / 60);
	const secs = seconds % 60;

	return isNegative ? `${hours}:${minutes}` : `${hours}:${minutes}`;
}

export function secondsToTimeNegative(seconds: number): string {
	let isNegative = seconds < 0;
	if (isNegative) {
		seconds = Math.abs(seconds);
	}

	const hours = Math.floor(seconds / 3600);
	seconds -= hours * 3600;

	const minutes = Math.floor(seconds / 60);
	const secs = seconds % 60;

	return isNegative ? `-${hours}:${minutes}` : `-${hours}:${minutes}`;
}

export function formatMinutesToHoursMinutes(minutes: number): string {
	const hrs = Math.floor(minutes / 60);
	const mins = minutes % 60;
	return `${hrs}:${mins.toString().padStart(2, "0")}`;
}

const converterData = (data: string): string => {
	const parts = data.split("-");
	if (parts.length !== 3) {
		throw new Error("Data inválida");
	}
	return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

export function getDataDispDiariaVeiculos(date: Date): {
	data1Disp: string;
	data2Disp: string;
} {
	let data1Disp = converterData(
		new Date(date.getFullYear(), date.getMonth(), date.getDate() - 2)
			.toLocaleDateString("pt-BR", {
				year: "numeric",
				month: "numeric",
				day: "numeric",
			})
			.replace(/\//g, "-"),
	);
	let ultimoDiaDisp = new Date(
		date.getFullYear(),
		date.getMonth(),
		date.getDate() + 8,
	)
		.toLocaleDateString("pt-BR", {
			year: "numeric",
			month: "numeric",
			day: "numeric",
		})
		.replace(/\//g, "-");
	let data2Disp = converterData(ultimoDiaDisp);
	return { data1Disp, data2Disp };
}

export const formatarDataISO = (dataString: string): string => {
	const data = new Date(dataString);
	if (isNaN(data.getTime())) {
		throw new Error("Data inválida");
	}
	const dia = data.getDate().toString().padStart(2, "0");
	const mes = (data.getMonth() + 1).toString().padStart(2, "0");
	const ano = data.getFullYear();
	return `${ano}-${mes}-${dia}`;
};
